// extracted by mini-css-extract-plugin
export default {"zoomModal":"b4-z","image":"c4-z","button":"d4-z","isOverlayShown":"e4-z"};